import React from 'react';

export const TYPES = {
  game: 'game',
  selo: 'selo',
  dom: 'dom',
  industry: 'industry',
  telemed: 'telemed',
  electrobus: 'electrobus',
  vr: 'vr',
  zone: 'zone',
};

export const CONFIG = {
  [TYPES.game]: {
    image: 'Technologies__banner-image--gaming',
    title: 'Облачный гейминг',
    text: (
      <span>
        В последние годы на рынке стали появляться облачные игровые сервисы, для
        которых требуется не только высокая скорость интернета, но также
        стабильная связь и минимальные задержки. Игры в них запускаются не на
        устройстве пользователя, а на удаленном сервере, пользователь же
        фактически видит онлайн-трансляцию собственного игрового процесса. Этот
        подход обещает стать революцией для игровой индустрии, впервые избавив
        от необходимости постоянно обновлять игровые устройства, которые
        устаревают примерно раз в 5 лет. Однако для полноценной реализации этой
        революции без 5G не обойтись. Теперь пользователю нужно бесперебойное
        высокоскоростное интернет-соединение, которое позволило бы получать
        потоковое видео в высоком разрешении без малейших задержек.
        <br />
        <br />
        Пока у многих таких сервисов наблюдаются проблемы из-за неготовности
        инфраструктуры к таким нагрузкам. Но прорыв должен случиться уже в
        ближайшем будущем, когда сети 5G начнут активно разворачиваться по всему
        миру. Если в 2018 году весь этот рынок оценивался в $1 млрд, то, по
        оценкам Global Market Insights, к 2025 году его объем достигнет уже $8
        млрд.
        <br />
        <br />В конце августа в Москве был проведен первый в России
        киберспортивный турнир с использованием не только облачного гейминга, но
        и технологий 5G, организованный МегаФоном вместе с холдингом ESforce. В
        ходе соревнований оператор продемонстрировал реальное применение и
        работу действующей 5G-базовой станции в Москва-Сити. Для этого МегаФон
        объединил в одну экосистему 5G-оборудование от Huawei и облачные
        технологии от платформы Loudplay. Как результат – скорость интернета в
        сетях 5G в сочетании с возможностями «облаков» позволила играть в
        онлайн-игры, используя самые доступные компьютеры и обычный смартфон в
        качестве модема.
      </span>
    ),
  },
  [TYPES.selo]: {
    image: 'Technologies__banner-image--selo',
    title: 'Сельское хозяйство',
    text: (
      <span>
        Среди сфер экономики, где произойдет настоящий прорыв благодаря
        распространению сетей 5G, окажется и самая древняя – сельское хозяйство.
        Благодаря 5G доступ к дешевому и быстрому интернет-соединению получат
        сельские районы. А сочетание нового стандарта связи с беспилотниками,
        сенсорами и датчиками, а также с AI поможет автоматизировать процесс,
        улучшить контроль урожая и домашнего скота. В конечном счете это сделает
        сельское хозяйство гораздо эффективнее, что для человечества жизненно
        необходимо. По прогнозам ООН, к 2050 году люди должны будут производить
        на 50% больше еды, чем сейчас, чтобы прокормить себя.
        <br />
        <br />
        Внедрение 5G в сельское хозяйство идет активными темпами. Так, Cisco
        запустила приложение «Me+Moo», которое позволяет фермерам в английском
        графстве Сомерсет все время оставаться на связи со своими коровами. Все
        животные на ферме носят 5G-ошейники, которые круглосуточно передают
        информацию о том, как чувствуют себя коровы, что они ели, как они спали
        и т.д. А фермеры могут тут же передать эту информацию ветеринарам.
        <br />
        <br />
        Согласно оценкам MarketsandMarkets, рынок беспилотников, используемых в
        сельском хозяйстве, вырастет с нынешних $1,2 млрд до $6,5 млрд по итогам
        2026 года. Использование дронов позволяет фермерам получать изображение
        о состоянии урожая или следить за пасущимся скотом. Однако без 5G зона
        работы беспилотника ограничена в среднем 500 метрами от оператора.
        Появление сетей связи нового поколения расширит границы их работы в
        разы. Например, китайская ZTE и нидерландский оператор связи KPN еще в
        прошлом году провели удачный эксперимент по внедрению беспилотников в
        процесс выращивания картофеля в провинции Дренте. Изображение с дрона
        поступало напрямую оператору сельхозтехники, что позволяло предельно
        точно дозировать средства для защиты урожая от сорняков.
      </span>
    ),
  },
  [TYPES.dom]: {
    image: 'Technologies__banner-image--dom',
    title: 'Умный дом',
    text: (
      <span>
        История «умного дома» как системы, обеспечивающей безопасность,
        ресурсосбережение и комфорт для пользователей, насчитывает уже несколько
        десятилетий. А с повсеместным распространением интернета и подключением
        к нему физических предметов на рубеже веков появилась и концепция
        «интернета вещей» (IoT), частью которой стал и «умный дом». Основными
        его элементами являются бытовые устройства с возможностью их подключения
        к Сети. Датчики, отслеживающие протечку воды, и «умный» кондиционер –
        лишь вершина айсберга. На рынке уже давно есть «умные» телевизоры,
        роботы-пылесосы и даже «умные» холодильники, способные отслеживать
        количество продуктов и самостоятельно пополнять запасы, заказывая новые
        в магазине. А если добавить к перечню «умных» устройств еще и единый
        центр управления, то в распоряжении у пользователя будет настоящая
        система «умного» дома.
        <br />
        <br />В будущем «умные» дома станут нормой, в каждом из них будут сотни
        устройств, 24 часа в сутки получающих и отправляющих данные через
        интернет. А учитывая, что речь и о системах безопасности, которые
        записывают и отправляют на облачные серверы видео с камер наблюдения,
        объемы данных могут исчисляться терабайтами в день. Очевидно, для такого
        будущего нужны средства связи, которые обеспечат не только высокую
        скорость интернет-соединения, но и бесперебойную связь для сотен
        устройств одновременно. Все это и сможет обеспечить 5G.
        <br />
        <br />
        Проект «умного здания» с использованием искусственного интеллекта,
        роботов, IoT и сети 5G показала в апреле Huawei. Он будет реализован
        совместно с сетью отелей Hotel InterContinental Shenzhen и
        телекоммуникационной компанией China Telecom Shenzhen. Регистрация
        гостей будет происходить при помощи системы распознавания лиц, чемоданы
        отвезут в номер роботы, а в самих номерах гостям будет доступен не
        просто быстрый доступ в интернет, но и полный спектр развлечений,
        включая VR/AR, облачный гейминг и просмотр видео с разрешением 4К/8К.
      </span>
    ),
  },
  [TYPES.industry]: {
    image: 'Technologies__banner-image--robo',
    title: 'Промышленность',
    text: (
      <span>
        Человечество готовится к «четвертой промышленной революции», которая
        должна вот-вот наступить. Термин появился в 2011 году после того как
        бизнесмены, ученые и политики Германии выступили с инициативой повысить
        конкурентоспособность промышленности с помощью внедрения киберфизических
        систем в заводские процессы. В широком смысле «Индустрия 4.0»
        предполагает переход на полностью автоматизированное цифровое
        производство, управляемое интеллектуальными системами в постоянном
        взаимодействии с внешней средой. Неотъемлемым элементом для нее станет
        развертывание сетей связи стандарта 5G.
        <br />
        <br />
        Именно сети 5G позволят роботам и автономным устройствам свободно
        перемещаться по заводам и фабрикам, одновременно передавая массивы
        данных на другие устройства и в центры управления производством. Это
        поможет не только автоматизировать процесс, но и усовершенствовать
        производственный контроль, давая возможность руководству корректировать
        производственный процесс в максимально сжатые сроки. Кроме того, с 5G
        станет доступнее и стабильнее дистанционное управление машинами,
        роботами, беспилотниками и погрузчиками в ситуациях, сопряженных с
        опасностью для жизни и здоровья человека. Так, Huawei совместно с Yuexin
        Intelligent Machinery развернули сеть 5G на молибденовом руднике в
        Китае. Она используется для системы автономного вождения карьерных
        самосвалов и дистанционного управления экскаваторами.
        <br />
        <br />
        По данным Capgemini, около 800 промышленных компаний по всему миру уже
        сейчас изучают возможности, которые может открыть перед ними
        распространение 5G. Среди них, к примеру, Audi, которая вместе с
        Ericsson в августе 2018 года начала серию тестовых испытаний применения
        5G в производстве. В числе прочих автопроизводитель испытывал систему
        удаленного управления движениями роботов на производстве. Глава Audi
        Production Lab Хеннинг Лозер назвал итоги этих испытаний «крайне
        удовлетворительными».
      </span>
    ),
  },
  [TYPES.telemed]: {
    image: 'Technologies__banner-image--med',
    title: 'Телемедицина',
    text: (
      <span>
        Новейшие цифровые технологии и медицинские разработки позволяют
        консультировать больного на расстоянии и даже проводить сложные
        медицинские процедуры удаленно. Но это требует не только современной
        медицинской аппаратуры, но и самых передовых телекоммуникационных
        технологий, поэтому представить телемедицину завтрашнего дня без 5G
        невозможно.
        <br />
        <br />
        В России уже проводятся испытания цифровых решений в области медицины с
        использованием сетей 5G. Впервые возможности телемедицины от МегаФона
        компания продемонстрировала на Moscow Urban Forum в июле 2018 года.
        Оператор вместе с Huawei и департаментами информтехнологий и
        здравоохранения Москвы успешно показал, как удаленно провести УЗИ и
        генетическое секвенирование (по сути, расшифровку ДНК).
        <br />
        <br />
        Так, для удаленного УЗИ использовалась роботизированная рука. Врач
        управлял ей дистанционно, опираясь на HD-видео в режиме реального
        времени от пациента. Робот способен передавать все виды информации,
        включая тактильную, а доктор и пациент могут общаться с помощью
        видеосвязи. Очевидно, для проведения УЗИ пациент и врач должны постоянно
        оставаться на связи, а разрешение видеоизображения играет критическую
        роль для корректности процедуры и результатов обследования. Что касается
        секвенирования ДНК, то для оперативного анализа нужно отправить
        медсотруднику огромный объем данных, необходимых для расшифровки. В
        случае с тестом МегаФона это были 140 ГБ данных. Провести обе эти
        процедуры удаленно возможно только с использованием сетей 5G.
      </span>
    ),
  },
  [TYPES.electrobus]: {
    image: 'Technologies__banner-image--kamaz',
    title: 'Беспилотный транспорт',
    text: (
      <span>
        По статистике, 88% аварий на дорогах происходит по вине водителя.
        Значительно улучшить ситуацию с количеством автомобильных ДТП должен
        беспилотный транспорт. Для этого искусственный интеллект, управляющий
        авто, должен идеально видеть окружающую его среду, ежесекундно верно
        оценивать ситуацию на дороге и уметь моментально реагировать на любые
        изменения. Но когда эпоха беспилотных автомобилей со встроенными
        датчиками все же настанет, им понадобится еще и общаться с
        инфраструктурой и между собой. Именно эту возможность и обеспечат сети
        5G, которые позволяют сотням автомобилей обмениваться большими объемами
        данных без задержек и перебоев.
        <br />
        <br />
        В России уже реализуются тестовые проекты использования беспилотного
        транспорта с подключением к сетям 5G. Так, детище «КамАЗа» и НАМИ под
        названием «ШАТЛ» возило гостей чемпионата мира по футболу в 2018 году в
        Казани. Автобус беспилотный, но ему, помимо зарядных станций и прочей
        инфраструктуры на дороге, необходима устойчивая и высокоскоростная связь
        с центром управления, где сидят сотрудники, контролирующие его работу.
        Автобус передает в центр огромное количество данных, включая потоковое
        видео со своих камер, коих у него восемь, и информацию о техническом
        состоянии машины. Передавать столь большие объемы данных без задержек
        возможно только в сетях 5G, которые развернул в Казани МегаФон. В
        результате любой желающий мог проехать часть пути по дороге от фан-зоны
        к стадиону «Казань Арена».
        <br />
        <br />А год назад шведские компании Telia, Ericsson и Einride запустили
        «пилот» перевозки грузов для логистической компании DB Schenker. Теперь
        логистику со склада в Йенчепинге обеспечивают беспилотные электрические
        грузовики, связь с которыми обеспечивает экспериментальная зона сети 5G
        от Telia.
      </span>
    ),
  },
  [TYPES.vr]: {
    image: 'Technologies__banner-image--vr',
    title: 'VR/AR',
    text: (
      <span>
        Технологии VR и AR уже используются в сфере развлечений, для тренировки
        машинистов и пилотов на современных симуляторах, в торговле,
        недвижимости, образовании, здравоохранении и военной промышленности.
        Внедрение 5G должно вывести VR и AR на качественно новый уровень. Так,
        VR-оборудование больше не будет нуждаться в проводном подключении к
        компьютерам и сможет работать с любыми мобильными устройствами. Кроме
        того, 5G принесет с собой 10-кратное сокращение времени отклика серверов
        на запросы пользователей по сравнению с 4G, что особо критично для
        игровой сферы, ведь даже едва заметные задержки и зависания способны
        вызвать у пользователя VR-шлемов чувство укачивания.
        <br />
        <br />
        Применение же AR сейчас сильно ограничено: она требует от устройств
        очень высокой мощности для беспрерывных вычислений, а одновременное
        подключение большого количества AR-гаджетов к одной сети невозможно. С
        развертыванием 5G проблемы останутся в прошлом: участвовать в одном
        AR-эксперименте смогут тысячи пользователей, а все вычисления,
        необходимые для бесперебойной трансляции изображения, будут перенесены с
        гаджетов в «облако».
        <br />
        <br />В России первая VR-трансляция спортивного события с использованием
        5G состоялась 5 июня 2018 года. Для показа в новом формате был выбран
        футбольный товарищеский матч Россия – Турция на «ВЭБ Арене» в Москве.
        Новый тип трансляции обеспечил МегаФон с помощью пятью VR-камер с углом
        обзора в 180°, изображение и звук с которых передавались на VR-шлемы
        зрителей через пилотную зону 5G, развернутую в офисе МегаФона. Другой
        наглядный пример – от южнокорейского оператора SKTelecom, объединившего
        5G, VR и AR, чтобы в марте 2019 года призвать на стадион Happy Dream
        Park огнедышащего дракона, которого зрители на стадионе могли увидеть с
        помощью смартфонов.
      </span>
    ),
  },
  [TYPES.zone]: {
    image: 'Technologies__banner-image--gorod',
    title: 'Умный город',
    text: (
      <span>
        Понятие «умного города» включает в себя использование информтехнологий –
        и искусственного интеллекта в частности – в управлении городским
        имуществом и при работе с населением. С технической точки зрения,
        «умный» город – колоссальная цифровая экосистема, объединяющая сотни
        тысяч устройств, «общающихся» между собой и передающих данные в центры
        управления в формате 24/7. Чтобы вся эта гигантская система могла
        корректно работать, ей нужна надежная связь. Обеспечить
        высокоскоростным, бесперебойным интернет-соединением огромное количество
        устройств в состоянии только сети 5G.
        <br />
        <br />
        Одним из самых высокотехнологичных городов мира является Дубай, власти
        которого уже запустили множество интеллектуальных услуг и программ. Так,
        Intel совместно с Huawei разработали систему умных автобусов, которая
        позволяет отслеживать местоположение общественного транспорта. А система
        мониторинга микроклимата Bosch Micro-Climate Monitoring System
        круглосуточно мониторит содержание загрязняющих веществ в воздухе, его
        температуру, влажность и уровень освещенности.
        <br />
        <br />В Москве граждане уже давно могут записаться на прием к врачу или
        оплатить счета за коммунальные услуги, не выходя из дома. В этой сфере
        работает и МегаФон. В частности, сотовый оператор представил систему
        «умного ЖКХ» – систему сбора данных с умных датчиков учета воды, света,
        тепла и пожарной сигнализации для передачи в личный кабинет управляющей
        компании. Кроме того, оператор разработал проект «цифровой управляющей
        компании», который предусматривает создание системы автоматизированной
        связи между жильцами и управляющей компанией. Она позволит
        автоматизировать и упростить заявку и обработку обращений жильцов, а
        также проводить онлайн-голосования по важным для жителей вопросам.
      </span>
    ),
    link: null,
  },
};
